import { render } from "./formContact.vue?vue&type=template&id=2fb2a655"
import script from "./formContact.vue?vue&type=script&lang=js"
export * from "./formContact.vue?vue&type=script&lang=js"

import "./formContact.vue?vue&type=style&index=0&id=2fb2a655&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__